import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import MockupConfigurator from "./MockupConfigurator";

const Heroicon = ({ path, className = "h-3 w-3", spin = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    className={`${className}${spin ? " animate-spin" : ""}`}
  >
    {path}
  </svg>
);

const ICONS = {
  arrowLeft: (
    <path
      fillRule="evenodd"
      d="M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z"
      clipRule="evenodd"
    />
  ),
  arrowTopRightOnSquare: (
    <path
      fillRule="evenodd"
      d="M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Zm6.836-1.281a.75.75 0 0 1 .75-.75h4.288a.75.75 0 0 1 .75.75v4.288a.75.75 0 0 1-1.5 0V5.811l-5.97 5.97a.75.75 0 1 1-1.06-1.061l5.97-5.97h-2.478a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
  ),
  sparkles: (
    <path
      fillRule="evenodd"
      d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036a2.63 2.63 0 001.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258a2.63 2.63 0 00-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395a1.5 1.5 0 00-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395a1.5 1.5 0 00.948-.948l.395-1.183A.75.75 0 0116.5 15z"
      clipRule="evenodd"
    />
  ),
  checkCircle: (
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
      clipRule="evenodd"
    />
  ),
  arrowPath: (
    <path
      fillRule="evenodd"
      d="M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0v2.43l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z"
      clipRule="evenodd"
    />
  ),
  arrowDownTray: (
    <>
      <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
      <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
    </>
  ),
};

const downloadFromUrl = async (url, filename, button) => {
  if (button) button.classList.add("downloading");
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Download failed:", err);
    // eslint-disable-next-line no-alert
    alert(
      'Download failed. Please right-click the image and choose "Save image as..." instead.',
    );
  } finally {
    if (button) {
      setTimeout(() => button.classList.remove("downloading"), 800);
    }
  }
};

const buildSearchQueryString = (searchParams) => {
  const usp = new URLSearchParams();
  Object.entries(searchParams || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    usp.append(`search[${key}]`, value);
  });
  return usp.toString();
};

const MockupSectionHeader = ({
  number,
  kicker,
  title,
  spec,
  downloadUrl,
  downloadFilename,
}) => (
  <div className="flex items-center h-9 px-6 lg:px-8 gap-2 bg-[#F6F4EE] border-y border-[#E4E0D6] flex-wrap">
    <span className="text-[10px] font-medium uppercase tracking-[0.08em] text-[#9A9890] shrink-0">
      {number} — {kicker}
    </span>
    <span className="text-[10px] uppercase tracking-[0.06em] text-[#111111] truncate min-w-0">
      {title}
    </span>
    {spec && (
      <span className="font-mono text-[10px] text-[#9A9890] hidden sm:inline shrink-0">
        {spec}
      </span>
    )}
    <span className="ml-auto" />
    <button
      type="button"
      onClick={(e) => downloadFromUrl(downloadUrl, downloadFilename, e.currentTarget)}
      className="inline-flex items-center h-7 rounded-md px-2.5 gap-1.5 border border-[#E4E0D6] bg-white text-[11px] font-medium text-[#111111] hover:bg-[#FAF8F2] cursor-pointer transition-colors shrink-0"
      aria-label="Download mockup"
    >
      <Heroicon path={ICONS.arrowDownTray} />
      Download
    </button>
  </div>
);

const MockupImage = ({ src, alt, className = "", style, frameShadow = false }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <>
      {!loaded && (
        <div className="mockup-spinner">
          <Heroicon
            path={ICONS.arrowPath}
            className="h-6 w-6 text-[#9A9890]"
            spin
          />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={`max-w-full h-auto${frameShadow ? " big-frame-shadow" : ""} ${className}`}
        style={{ ...style, display: loaded ? undefined : "none" }}
      />
    </>
  );
};

const ConfiguredPill = () => (
  <span className="inline-flex items-center h-4 rounded-lg px-1.5 bg-[#FFFBF0] border border-[#EADFBE] shrink-0">
    <Heroicon
      path={ICONS.checkCircle}
      className="h-2.5 w-2.5 text-[#7A5A0F] shrink-0"
    />
    <span className="text-[9px] font-medium uppercase tracking-[0.05em] text-[#7A5A0F] whitespace-nowrap ml-1">
      Configured
    </span>
  </span>
);

const ActiveConfigurationStrip = ({ summary }) => (
  <div className="flex items-center py-3 px-6 lg:px-8 gap-2 bg-[#FFFBF0] border-b border-[#EADFBE] flex-wrap">
    <Heroicon
      path={ICONS.checkCircle}
      className="h-3.5 w-3.5 text-[#7A5A0F] shrink-0"
    />
    <span className="text-[11px] font-medium uppercase tracking-[0.04em] text-[#7A5A0F]">
      Active configuration
    </span>
    <span className="text-[12px] text-[#7A5A0F] min-w-0 truncate">
      {summary.sizeDescription}
      {summary.borderLabel ? ` · ${summary.borderLabel}` : ""}
      {summary.frameDescription ? ` · ${summary.frameDescription}` : ""}
    </span>
  </div>
);

const EmptyState = ({ source = {} }) => (
  <div className="flex flex-col items-center justify-center text-center py-20 px-8 m-6 lg:m-8 border border-dashed border-[#E4E0D6] rounded-lg bg-[#FAFAF7]">
    {source.previewUrl ? (
      <div className="relative w-full max-w-sm rounded overflow-hidden bg-stone-900 mb-5">
        <img
          src={source.previewUrl}
          alt={source.filename}
          className="w-full h-auto block"
          style={{ aspectRatio: "4 / 3", objectFit: "cover" }}
          loading="lazy"
        />
        <div
          className="absolute bottom-0 left-0 right-0 px-3 pt-8 pb-2.5 flex justify-between items-end text-white"
          style={{
            background:
              "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%)",
          }}
        >
          <span className="text-[10px] tracking-[0.1em] uppercase font-medium">
            Source artwork
          </span>
          {source.dimensions && (
            <span className="text-[10px] tracking-[0.05em] font-mono opacity-90">
              {source.dimensions}
            </span>
          )}
        </div>
      </div>
    ) : (
      <div className="w-12 h-12 rounded-full bg-white border border-[#E4E0D6] flex items-center justify-center mb-4">
        <Heroicon path={ICONS.sparkles} className="h-5 w-5 text-[#9A9890]" />
      </div>
    )}
    <h3 className="text-[15px] font-semibold text-[#111111] m-0 mb-1">
      Pick a size, border treatment and frame
    </h3>
    <p className="text-[12px] text-[#6B6B66] max-w-sm m-0 leading-[16px]">
      Choose your configuration in the panel on the left and we&apos;ll render
      mockups you can download instantly.
    </p>
  </div>
);

const MockupResults = ({ data, isLoading, error, source }) => {
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-16 px-8 m-6 lg:m-8 border border-dashed border-[#E4D6D6] rounded-lg bg-[#FFF5F5]">
        <h3 className="text-[14px] font-semibold text-[#7A1F1F] m-0 mb-1">
          Couldn&apos;t generate mockups
        </h3>
        <p className="text-[12px] text-[#7A1F1F] max-w-sm m-0 leading-[16px]">
          {error}
        </p>
      </div>
    );
  }

  if (!data) {
    return <EmptyState source={source} />;
  }

  return (
    <>
      <ActiveConfigurationStrip summary={data.summary} />

      {/* 01 — Transparent background */}
      <div>
        <MockupSectionHeader
          number="01"
          kicker="Transparent background"
          title="Framed image mockup"
          spec={"1600px long edge \u00b7 PNG"}
          downloadUrl={data.framedMockup.downloadUrl}
          downloadFilename={data.framedMockup.downloadFilename}
        />
        <div
          className={`mockup-checker flex items-center justify-center p-10 lg:p-16${
            isLoading ? " opacity-60" : ""
          }`}
        >
          <MockupImage
            src={data.framedMockup.url}
            alt="Framed mockup"
            style={{ maxHeight: "640px" }}
            frameShadow
          />
        </div>
      </div>

      {/* 02 — Pale grey background */}
      <div>
        <MockupSectionHeader
          number="02"
          kicker="Pale grey background"
          title="Studio backdrop"
          spec={"2048 \u00d7 2048px \u00b7 JPG"}
          downloadUrl={data.plainBg.downloadUrl}
          downloadFilename={data.plainBg.downloadFilename}
        />
        <div
          className={`flex items-center justify-center p-10 lg:p-16 bg-[#FAFAF7]${
            isLoading ? " opacity-60" : ""
          }`}
        >
          <MockupImage
            src={data.plainBg.url}
            alt="Plain background mockup"
            style={{ maxHeight: "640px" }}
          />
        </div>
      </div>

      {/* 03 — Interior mockups */}
      <div>
        <div className="flex items-center h-9 px-6 lg:px-8 gap-2 bg-[#F6F4EE] border-y border-[#E4E0D6] flex-wrap">
          <span className="text-[10px] font-medium uppercase tracking-[0.08em] text-[#9A9890] shrink-0">
            03 — In context
          </span>
          <span className="text-[10px] uppercase tracking-[0.06em] text-[#111111] truncate min-w-0">
            Interior mockups
          </span>
          <span className="font-mono text-[10px] text-[#9A9890] hidden sm:inline shrink-0">
            1000 &times; 1000px · Not to accurate scale
          </span>
        </div>
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-6 lg:p-8 bg-[#FAFAF7]${
            isLoading ? " opacity-60" : ""
          }`}
        >
          {data.interiorMockups.map((interior) => (
            <div
              key={interior.id}
              className="relative group rounded-md overflow-hidden bg-[#111111] border border-[#E4E0D6]"
            >
              <img
                src={interior.url}
                alt={interior.title}
                className="w-full h-auto block aspect-square object-cover"
              />
              <div
                className="absolute inset-x-0 bottom-0 px-3 py-2.5 flex items-end justify-between gap-2"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)",
                }}
              >
                <span className="text-[10px] font-mono tracking-[0.08em] uppercase text-white drop-shadow-sm truncate">
                  {interior.title}
                </span>
                <button
                  type="button"
                  onClick={(e) =>
                    downloadFromUrl(
                      interior.url,
                      interior.downloadFilename,
                      e.currentTarget,
                    )
                  }
                  className="mockup-icon-btn shrink-0"
                  aria-label="Download mockup"
                >
                  <Heroicon path={ICONS.arrowDownTray} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const truncateText = (text, length) => {
  if (!text) return text;
  return text.length > length ? `${text.slice(0, length - 1)}\u2026` : text;
};

const MockupStudio = ({
  upload = {},
  paths = {},
  metaPillParts = [],
  configurator = {},
  initialMockupData = null,
  internalNavigate = null,
}) => {
  const [mockupData, setMockupData] = useState(initialMockupData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const initialOutsideDimensions = initialMockupData?.summary?.outsideDimensions || null;
  const [outsideDimensions, setOutsideDimensions] = useState(
    initialOutsideDimensions,
  );
  const requestSeqRef = useRef(0);

  const displayBasename = useMemo(() => {
    const filename = upload.filename || "";
    const dot = filename.lastIndexOf(".");
    return dot > 0 ? filename.slice(0, dot) : filename;
  }, [upload.filename]);

  const handleSubmit = useCallback(
    async (values) => {
      const seq = ++requestSeqRef.current;
      setIsLoading(true);
      setError(null);

      try {
        const queryString = buildSearchQueryString(values);
        const url = `${paths.mockupDataUrl}?${queryString}`;
        const response = await fetch(url, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const json = await response.json();

        if (seq !== requestSeqRef.current) return;

        if (json.configured === false) {
          setMockupData(null);
          setOutsideDimensions(null);
          setError("Couldn't build a frame from the selected configuration.");
        } else {
          setMockupData(json);
          setOutsideDimensions(json.summary?.outsideDimensions || null);

          if (paths.previewUrl && typeof window !== "undefined") {
            try {
              const newQs = buildSearchQueryString(json.searchParams || values);
              const newPath = `${paths.previewUrl}?${newQs}`;
              window.history.replaceState({}, "", newPath);
            } catch (e) {
              // ignore history failures
            }
          }
        }
      } catch (err) {
        if (seq !== requestSeqRef.current) return;
        // eslint-disable-next-line no-console
        console.error("Mockup generation failed:", err);
        setError(
          err && err.message ? err.message : "Something went wrong. Please try again.",
        );
      } finally {
        if (seq === requestSeqRef.current) {
          setIsLoading(false);
        }
      }
    },
    [paths.mockupDataUrl, paths.previewUrl],
  );

  const sourceForConfigurator = {
    ...(configurator.source || {}),
    outsideDimensions,
  };

  const handleInternalNavigation = useCallback(
    (event, url) => {
      if (!internalNavigate || !url) return;

      event.preventDefault();
      internalNavigate(url);
    },
    [internalNavigate],
  );

  return (
    <div className="flex flex-col gap-6 max-w-7xl mx-auto w-full">
      <style>
        {`
          .mockup-checker {
            background-color: #FAFAF7;
            background-image:
              linear-gradient(45deg, #F0EFEC 25%, transparent 25%),
              linear-gradient(-45deg, #F0EFEC 25%, transparent 25%),
              linear-gradient(45deg, transparent 75%, #F0EFEC 75%),
              linear-gradient(-45deg, transparent 75%, #F0EFEC 75%);
            background-size: 24px 24px;
            background-position: 0 0, 0 12px, 12px -12px, 12px 0;
          }
          .mockup-spinner {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 200px;
            width: 100%;
          }
          .mockup-icon-btn {
            width: 26px;
            height: 26px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 0.95);
            border: 1px solid rgba(228, 224, 214, 0.6);
            color: #111111;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: background 0.15s ease;
          }
          .mockup-icon-btn:hover { background: #ffffff; }
          .mockup-icon-btn.downloading { pointer-events: none; opacity: 0.7; }
          .big-frame-shadow {
            filter: drop-shadow(0 30px 40px rgba(0,0,0,0.18)) drop-shadow(0 12px 16px rgba(0,0,0,0.1));
          }
        `}
      </style>
      {/* ---------- Page header ---------- */}
      <div className="flex flex-col gap-2">
        <nav
          aria-label="Breadcrumb"
          className="flex items-center gap-1.5 text-[12px] text-[#6B6B66]"
        >
          <a href={paths.dashboardUrl} className="hover:text-[#111111] no-underline">
            Pro Dashboard
          </a>
          <span className="text-[#9A9890]">/</span>
          <a
            href={paths.uploadsUrl}
            onClick={(event) => handleInternalNavigation(event, paths.uploadsUrl)}
            className="hover:text-[#111111] no-underline"
          >
            Uploads
          </a>
          <span className="text-[#9A9890]">/</span>
          <a
            href={paths.uploadShowUrl}
            onClick={(event) =>
              handleInternalNavigation(event, paths.uploadShowUrl)
            }
            className="hover:text-[#111111] truncate max-w-[280px] no-underline"
          >
            {truncateText(displayBasename, 40)}
          </a>
          <span className="text-[#9A9890]">/</span>
          <span className="text-[#111111]">Mockup studio</span>
        </nav>

        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-baseline gap-2 min-w-0">
            <h1
              className="text-2xl font-bold tracking-[-0.01em] text-[#111111] truncate"
              title={upload.filename}
            >
              Mockup studio
            </h1>
            {metaPillParts.map((part, idx) => (
              <span
                key={idx}
                className="inline-flex items-center h-4 rounded-lg px-1.5 bg-[#F6F4EE] shrink-0"
              >
                <span className="font-mono text-[10px] font-medium text-[#6B6B66] whitespace-nowrap">
                  {part}
                </span>
              </span>
            ))}
            {mockupData && <ConfiguredPill />}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a
              href={paths.uploadShowUrl}
              onClick={(event) =>
                handleInternalNavigation(event, paths.uploadShowUrl)
              }
              className="inline-flex items-center h-7 rounded-md px-2.5 gap-1.5 border border-[#E4E0D6] bg-white text-[11px] font-medium text-[#111111] hover:bg-[#FAF8F2] no-underline"
            >
              <Heroicon path={ICONS.arrowLeft} />
              Back to upload
            </a>
            <a
              href={paths.originalFileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center h-7 rounded-md px-2.5 gap-1.5 border border-[#E4E0D6] bg-white text-[11px] font-medium text-[#111111] hover:bg-[#FAF8F2] no-underline"
            >
              <Heroicon path={ICONS.arrowTopRightOnSquare} />
              Original file
            </a>
          </div>
        </div>
        <p className="text-[12px] text-[#6B6B66] m-0 max-w-2xl">
          <span className="font-medium text-[#111111]">
            For: {truncateText(displayBasename, 80)}
          </span>
          <span className="text-[#9A9890]">
            {" "}
            · Configure a frame and download production-ready mockups.
          </span>
        </p>
      </div>

      {/* ---------- Main 2-column layout ---------- */}
      <div className="rounded-lg border border-[#E4E0D6] bg-white overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* Left: configurator rail */}
          <aside className="lg:w-[340px] shrink-0 border-b lg:border-b-0 lg:border-r border-[#E4E0D6]">
            <div className="flex items-center h-9 px-6 gap-2 bg-[#F6F4EE] border-b border-[#E4E0D6]">
              <span className="text-[10px] font-medium uppercase tracking-[0.08em] text-[#9A9890]">
                Configure
              </span>
              <span className="text-[10px] uppercase tracking-[0.06em] text-[#111111]">
                Size, mat &amp; frame
              </span>
            </div>
            <div className="p-4 lg:p-5">
              <MockupConfigurator
                {...configurator}
                source={sourceForConfigurator}
                onSubmit={handleSubmit}
                isSubmitting={isLoading}
              />
            </div>
          </aside>

          {/* Right: rendered mockups */}
          <section className="flex-1 min-w-0">
            <MockupResults
              data={mockupData}
              isLoading={isLoading}
              error={error}
              source={configurator.source}
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export default MockupStudio;
